export const GROUP_SWITCH_SUCCESS = 'GROUP_SWITCH_SUCCESS';

const initialState = {
  groupId: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GROUP_SWITCH_SUCCESS:
      return {
        ...state,
        groupId: action.data
      };
    default:
      return state;
  }
}

export const actions = {};

actions.setGroupId = function setGroupId(dispatch, groupId) {
  dispatch({
    type: GROUP_SWITCH_SUCCESS,
    data: groupId
  });
};
